export default __webpack_public_path__ + "static/media/critical.14b46023.svg";